import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import find from 'lodash/find'
import debounce from 'lodash/debounce'
import { eplApi } from '@atheneum/api'
import { isEqual, pick } from 'lodash'

import WarningIcon from '@components/Icon/Warning'

import InfoIcon from '@components/Icon/Info'
import { Field } from 'formik'
import InfoBox from '@components/InfoBox'
import { Autocomplete } from '@components/Form/Autocomplete'

class ReportingFormGroup extends Component {
  static propTypes = {
    feeFormStore: PropTypes.object,
    form: PropTypes.object,
    isExpertInterviewed: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      projectedMargin: 0
    }
    this.handleRecalculateMargin(props.form)
  }

  handleRecalculateMargin = debounce(async (form) => {
    const callInfo = {
      fee: form.values.feeValue,
      honorarium: form.values.costValue,
      feeCurrencyId: form.values.feeCurrencyId,
      honorariumCurrencyId: form.values.costCurrencyId
    }
    const margin = await eplApi.recalculateMargin(callInfo)
    this.setState({
      projectedMargin: margin.projectedMargin
    })
  }, 300)

  componentDidUpdate(props) {
    const currProps = pick(props.form.values,
      ['feeValue', 'feeCurrencyId', 'costValue', 'costCurrencyId'])
    const nextProps = pick(this.props.form.values,
      ['feeValue', 'feeCurrencyId', 'costValue', 'costCurrencyId'])
    if (!isEqual(currProps, nextProps)) {
      this.handleRecalculateMargin(this.props.form)
    }
  }

  componentDidMount() {
    const self = this
    const { feeFormStore, form } = this.props
    const { fee } = feeFormStore
    feeFormStore.loadTeamInfoForEmployees(fee.employees.map(e => e.id))
    self.handleRecalculateMargin(form)
  }

  renderEmployeeInput() {
    const { form } = this.props
    const employees = this.props.feeFormStore.employees
    if (!employees.length) return

    return (
      <Field
        name='deliveredBy'
        label='Delivered by'
        itemToString={value => find(employees, { value })?.label}
        options={employees.map(e => e.value)}
        itemIsId
        onChange={item => {
          form.setFieldValue('deliveredBy', item, false)
        }}
        component={Autocomplete}
      />
    )
  }

  render() {
    const { feeFormStore, form, isExpertInterviewed } = this.props

    const { fee } = feeFormStore
    const { teamInfos } = feeFormStore

    const isEditForm = !!form.values.id

    return (
      <div className='expert-form__section'>
        <h2 className='expert-form__subtitle'>Reporting details</h2>
        {isExpertInterviewed || !isEditForm ? (
          <InfoBox className='m-b-xl' theme='blue' icon={<InfoIcon />}>
            {!isEditForm ? (
              <div>
                This is the team structure that will be recorded with this
                employee’s margins: if this is wrong please contact Ops Control
                to update the team information before submitting the bundle
              </div>
            ) : (
              ''
            )}
          </InfoBox>
        ) : (
          ''
        )}
        {fee.type === 'FEECOST' ? (
          <div className='expert-form__input-group'>
            <label className='expert-form__label'>Margin Percentage</label>
            <div className='expert-form__input-wrapper'>
              <div className='m-t-md'>
                {this.state.projectedMargin
                  ? (this.state.projectedMargin * 100).toFixed(2) + '%'
                  : 'N/A'}
              </div>
            </div>
          </div>
        ) : null}

        {this.renderEmployeeInput()}
        <TeamInfoSection teamInfo={teamInfos} />
      </div>
    )
  }
}

const TeamInfoSection = ({ teamInfo }) => {
  return teamInfo ? (
    <div className='team-info'>
      {!teamInfo || teamInfo.teamId === null ? (
        <InfoBox theme='red' icon={<WarningIcon />}>
          The employee is currently not assigned to any team: if this is wrong
          please contact Ops Control to update the team information before
          submitting the bundle.
        </InfoBox>
      ) : (
        ''
      )}
      <div>
        <span className='team-info__label'>Team Name:</span>
        <strong>{teamInfo.teamName}</strong>
      </div>
      <div>
        <span className='team-info__label'>Account Manager:</span>
        <strong>{teamInfo.accountManager}</strong>
      </div>
      <div>
        <span className='team-info__label'>Team Leader:</span>
        <strong>{teamInfo.teamLeader}</strong>
      </div>
    </div>
  ) : (
    <div>Team info unavailable</div>
  )
}
TeamInfoSection.propTypes = {
  teamInfo: PropTypes.object
}

export default inject(
  'staticData',
  'employeeStore'
)(observer(ReportingFormGroup))
